var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68752 0H14.7175L23.2182 8.86058V26.0945C23.2182 28.2534 21.4716 30 19.3202 30H4.68752C2.5286 30 0.781982 28.2534 0.781982 26.0945V3.90553C0.781945 1.74662 2.52857 0 4.68752 0Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.71 0V8.79311H23.2182L14.71 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12231 22.3836V16.9038H7.45366C8.03087 16.9038 8.48816 17.0612 8.83298 17.3836C9.1778 17.6984 9.35023 18.1257 9.35023 18.6579C9.35023 19.1902 9.1778 19.6175 8.83298 19.9323C8.48816 20.2546 8.03087 20.4121 7.45366 20.4121H6.52411V22.3836H5.12231ZM6.52411 19.2202H7.29624C7.50612 19.2202 7.67104 19.1752 7.7835 19.0703C7.89593 18.9728 7.95593 18.8379 7.95593 18.658C7.95593 18.4781 7.89597 18.3431 7.7835 18.2457C7.67108 18.1407 7.50616 18.0958 7.29624 18.0958H6.52411V19.2202ZM9.92741 22.3836V16.9038H11.8689C12.2512 16.9038 12.6111 16.9563 12.9484 17.0687C13.2857 17.1812 13.5931 17.3386 13.8629 17.556C14.1328 17.7659 14.3502 18.0507 14.5076 18.4106C14.6575 18.7704 14.74 19.1827 14.74 19.6474C14.74 20.1047 14.6576 20.517 14.5076 20.8768C14.3502 21.2366 14.1328 21.5215 13.8629 21.7314C13.593 21.9488 13.2857 22.1062 12.9484 22.2186C12.6111 22.3311 12.2512 22.3836 11.8689 22.3836H9.92741ZM11.2992 21.1917H11.704C11.9214 21.1917 12.1238 21.1692 12.3112 21.1167C12.4911 21.0643 12.6635 20.9818 12.8285 20.8693C12.9859 20.7569 13.1133 20.5995 13.2033 20.3896C13.2932 20.1797 13.3382 19.9323 13.3382 19.6474C13.3382 19.3551 13.2932 19.1077 13.2033 18.8978C13.1133 18.688 12.9859 18.5305 12.8285 18.4181C12.6635 18.3056 12.4911 18.2232 12.3112 18.1707C12.1238 18.1182 11.9214 18.0957 11.704 18.0957H11.2992V21.1917ZM15.4447 22.3836V16.9038H19.3427V18.0957H16.8465V18.9728H18.8404V20.1572H16.8465V22.3836H15.4447Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.d287b4825f104f48512cd0c27cf06907.svg";
export { ForwardRef as ReactComponent };